import { createSelector } from '@ngrx/store';
import { AuditLogEntry } from 'src/app/types/patient-audit.types';
import { AppState } from '../reducers';

export const selectLoadedOnce = (state: AppState) => state.patientAudit.loadedOnce;
export const selectLoading = (state: AppState) => state.patientAudit.loading;
export const selectQuery = (state: AppState) => state.patientAudit.query;
export const selectFilters = (state: AppState) => state.patientAudit.filters;
export const selectSortAscending = (state: AppState) => state.patientAudit.sortAscending;
export const selectDisplayCount = (state: AppState) => state.patientAudit.displayCount;
export const selectAuditLog = (state: AppState) => state.patientAudit.auditLog;

export const loadedOnce = createSelector(
	selectLoadedOnce,
	(loadedOnce) => loadedOnce
);

export const loading = createSelector(
	selectLoading,
	(loading) => loading
);

export const query = createSelector(
	selectQuery,
	(query) => query
);

export const filters = createSelector(
	selectFilters,
	(filters) => filters
);

export const sortAscending = createSelector(
	selectSortAscending,
	(sortAscending) => sortAscending
);

export const filteredAuditLog = createSelector(
	sortAscending,
	filters,
	selectAuditLog,
	(sortAscending, filters, auditLog) => [...auditLog]
		.filter(entry => (!filters.userId || entry.userId === filters.userId) && (!filters.fromDate || entry.timestamp >= filters.fromDate) && (!filters.toDate || entry.timestamp <= filters.toDate))
		.sort(sortAscending ? sortByTimestampAsc : sortByTimestampDesc)
);

export const auditLog = createSelector(
	filteredAuditLog,
	selectDisplayCount,
	(auditLog, displayCount) => auditLog.slice(0, displayCount)
);

export const remainingDisplayCount = createSelector(
	filteredAuditLog,
	auditLog,
	(filteredAuditLog, auditLog) => filteredAuditLog.length - auditLog.length
);

const sortByTimestampAsc = (a: AuditLogEntry, b: AuditLogEntry) => a.timestamp.localeCompare(b.timestamp);
const sortByTimestampDesc = (a: AuditLogEntry, b: AuditLogEntry) => b.timestamp.localeCompare(a.timestamp);